/* eslint-disable max-lines-per-function */
import React, { useState, useMemo } from 'react';
import {
  Box,
  Select,
  MenuItem,
  InputLabel,
  ListSubheader,
  TextField,
  InputAdornment,
  IconButton,
} from '@mui/material';
import { ReactComponent as SearchGlass } from '../../Assets/images/svg/dar_search.svg';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import PropTypes from 'prop-types';
import './dropdown.scss';
import { SEARCH } from '../../Constants/strings';
import ClearIcon from '@mui/icons-material/Clear';

const containsText = (text, searchText) =>
  text?.toLowerCase().indexOf(searchText.toLowerCase()) > -1;

const SearchDropdown = ({
  label,
  options = [],
  onChange,
  placeholder,
  value,
  dropdownCss,
  searchBox = true,
  disabled,
  clearIcon = false,
  customCss = {},
}) => {
  const [searchText, setSearchText] = useState('');

  const displayedOptions = useMemo(
    () =>
      (Array.isArray(options) ? options : []).filter((option) =>
        containsText(option.name, searchText),
      ),
    [searchText, options],
  );

  const handleClear = (event) => {
    event.stopPropagation();
    onChange({ target: { value: '' } });
  };

  return (
    <Box className={`common-dropdown-root ${dropdownCss}`}>
      <InputLabel className="dropdown-input-label">{label}</InputLabel>
      <Select
        className="common-dropdown"
        MenuProps={{
          PaperProps: {
            className: 'dropdown-paper',
          },
          autoFocus: false,
        }}
        id="search-dropdown"
        IconComponent={KeyboardArrowDownIcon}
        value={value}
        onChange={onChange}
        onClose={() => setSearchText('')}
        displayEmpty={true}
        renderValue={(selected) =>
          selected ? (
            selected.name || value
          ) : (
            <span className="dropdown-placeholder">{placeholder}</span>
          )
        }
        sx={customCss} // Custom CSS
        endAdornment={
          value
          && clearIcon && (
            <InputAdornment className="dropdown-clear-icon">
              <IconButton onClick={handleClear}>
                <ClearIcon></ClearIcon>
              </IconButton>
            </InputAdornment>
          )
        }
        fullWidth
        size="small"
        disabled={disabled}
      >
        <ListSubheader>
          {searchBox && (
            <TextField
              className="dropdown-text-field"
              size="small"
              autoFocus
              placeholder={SEARCH}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchGlass />
                  </InputAdornment>
                ),
              }}
              onChange={(event) => setSearchText(event.target.value)}
              onKeyDown={(event) => {
                if (event.key !== 'Escape') {
                  event.stopPropagation();
                }
              }}
            />
          )}
        </ListSubheader>
        {displayedOptions.map((option) => (
          <MenuItem
            className="dropdown-menu-item"
            key={option.id}
            value={option}
          >
            {option.name}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

SearchDropdown.propTypes = {
  options: PropTypes.array.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.any,
  value: PropTypes.any,
  dropdownCss: PropTypes.string,
  searchBox: PropTypes.bool,
  disabled: PropTypes.bool,
  clearIcon: PropTypes.bool,
  customCss: PropTypes.any,
};

export default SearchDropdown;
